import HeaderList from "../../components/HeaderList"
import { PageProps } from '../../components/types'
import Badge from "../../components/Badge"
import DataGrid, { FormatterProps } from 'react-data-grid'
import { PicklistStatus } from '../../constants/EnumType'
import { getColunmPicklist, PicklistApproveColumn } from '../../constants/Column'

import { useCallback, useMemo, useState } from "react";

import useApprovedOrderPicklist from '../../hooks/useApprovedOrderPicklist'

import { DgtPdOrderPicklist } from "../../models"

import { writeFile, utils } from 'xlsx';
import { RiFileExcel2Line } from 'react-icons/ri'
import { formatDateObject } from "../../utilities/Format"
import { groupBy } from "lodash"

const PicklistApprove = ({ title, division, line, from, to }: PageProps) => {
  const [orderType, setOrderType] = useState<string>(line || '')
  const [statuses, setStatuses] = useState<string[]>([ PicklistStatus.PD_RELEASED] )
  // note - for QAS environment, set fromDate and toDate to 2024-03-05
  const [dateRange, setDateRange] = useState<[Date, Date]>([ from || new Date(), to || new Date() ]);
  const [keyword, setKeyword] = useState<string>('')
  const [div, setDiv] = useState<string>(division!)

  const picklists = useApprovedOrderPicklist(statuses[0], orderType, dateRange[0], dateRange[1], keyword, div)

  const filterChanged = useCallback((
    key: string, value: string, dateRange?: [Date, Date], values?: string[]) => {
    switch(key) {
      case 'Order Type':
        return setOrderType(value)
      case 'Status':
        return setStatuses(values!)
      case 'Released Date Range':
        return setDateRange(dateRange!)
      case 'Search':
        return setKeyword(value)
      case 'Division':
        return setDiv(value)
      default:
        break
    }
  }, [])

  const coupleStatuses = useMemo(() => 
    [PicklistStatus.PD_RELEASED, PicklistStatus.PD_REQUESTED]
  , [])

  let columns = Array.from(getColunmPicklist(PicklistApproveColumn))
  columns.splice(3, 0, { key: 'batchLotNo', name: 'Batch no.', width: 105, formatter: (props: FormatterProps<DgtPdOrderPicklist>) => {
    const lots : string[] = props.row.batchLotNo ? props.row.batchLotNo.split(',') : []
    return <div className='space-y-1'>
      {lots.map(lot => <p key={lot}><Badge variant={` text-xs text-white bg-green-600`}>{lot}</Badge></p>)}
    </div>
  }, cellClass: "multi-line-row-data-grid" })

  const exportExcel = () => {
    const wb = utils.book_new();

    const groupByReleasedDate = groupBy(picklists, 'releasedDate')
    for(const dateKey of Object.keys(groupByReleasedDate)) {
      const ws = utils.json_to_sheet(groupByReleasedDate[dateKey])
      utils.book_append_sheet(wb, ws, dateKey);
    }

    const formattedDateStart = formatDateObject(dateRange[0])
    const formattedDateEnd = formatDateObject(dateRange[1])
    const exportDates = formattedDateStart === formattedDateEnd ? 
      formattedDateStart : `${formattedDateStart}_${formattedDateEnd}`
    writeFile(wb, `${statuses[0]}_${division}_${orderType}_${exportDates}.xlsx`);
  }

  return <div className="space-y-2 page-container">
    <HeaderList title={title} subTitle={`แผนก : ${division} - ${line}`}
      orderType={orderType}
      statuses={statuses}
      dateRange={dateRange}
      keywordSearch={keyword}
      coupleStatuses={coupleStatuses}
      filterChanged={filterChanged}
      division={div}
    />
    <div className="flex items-center justify-end">
      <button className='flex items-center gap-1 btn-outline-success ' onClick={exportExcel}><RiFileExcel2Line size={20} />Export Excel</button>
    </div>
    <DataGrid style={{ height: "100%", contain: "none" }}
      columns={columns}
      rows={picklists}
      defaultColumnOptions={{ resizable: true }}
      rowHeight={row => {
        const lots : string[] = row.row.batchLotNo ? row.row.batchLotNo.split(',') : []
        if (lots.length < 2) return 60
        return lots.length * 30
      }}
    />
  </div>
}

export default PicklistApprove